import { REFERRAL, TASK } from '@/modules/tasks/types';
import { RootStore } from '@/store';
import { apiRequest } from '@/utils';
import { storage } from '@/utils/storage';
import i18next from 'i18next';
import { makeAutoObservable } from 'mobx';

const CHAT_LANG_MAP: Record<string, string> = {
  ru: 'coopru',
  fa: 'farsi',
  ar: 'arab',
} as const;

export class TasksStore {
  readonly rootStore: RootStore;

  public tasks: TASK[] = [];
  public referrals: REFERRAL[] = [];

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }

  public dailyRewardsClaim = async () => {
    const [result] = await apiRequest([
      { path: '/v1/tasks/daily/claim', method: 'POST' },
    ]);
    await this.rootStore.accountStore.getAccountData();
    return result;
  };

  private filterTask = (tasks: TASK[]) => {
    return tasks.filter(({ data, claimed }) => {
      const dataString = data?.toString();
      return (
        !claimed &&
        !!dataString &&
        (!dataString.includes('@pollo') ||
          dataString === `@pollo${CHAT_LANG_MAP[i18next.language] ?? 'coop'}` ||
          dataString === '@polloverse' ||
          dataString.includes('youtube'))
      );
    });
  };

  private setTasks = (tasks: TASK[]) => {
    this.tasks = tasks;
  };

  public getTasks = async () => {
    const lang = await storage.getItem('lang');
    const [tasks] = await apiRequest(
      [
        {
          path: '/v1/tasks/list/' + lang,
          method: 'GET',
        },
      ],
      this.rootStore.errorStore,
    );
    const filteredTasks = this.filterTask(tasks.isError ? [] : tasks);
    this.setTasks(filteredTasks);
  };

  private setReferrals = (referrals: REFERRAL[]) => {
    this.referrals = referrals;
  };

  public getReferrals = async () => {
    const [referrals] = await apiRequest(
      [{ path: '/v1/referral/list', method: 'GET' }],
      this.rootStore.errorStore,
    );
    this.setReferrals(referrals);
  };

  public verifyTask = async (id: string) => {
    const [result] = await apiRequest([
      { path: '/v1/tasks/' + id + '/verify', method: 'POST' },
    ]);
    await this.getTasks();
    return result;
  };

  public claimTask = async (id: string) => {
    const [result] = await apiRequest([
      { path: '/v1/tasks/' + id + '/claim', method: 'POST' },
    ]);
    await this.getTasks();
    await this.rootStore.accountStore.getAccountData();
    return result;
  };
}
